import React from 'react';
import { tintFor } from '../../utils/tints';

/**
 * Bordered tinted square with an initial (or a photo when one exists).
 * No radius, no round avatars — handoff rule 4.
 */
export default function TintSquare({
  name = '',
  imageUrl,
  size = 34,
  fontSize,
  tintKey,
  className = '',
  style = {},
}) {
  const initial = (name || '?').trim().charAt(0).toUpperCase() || '?';
  const bg = tintFor(tintKey || name || initial);
  return (
    <span
      className={`flex flex-shrink-0 items-center justify-center overflow-hidden border-2 border-black ${className}`}
      style={{ width: size, height: size, background: imageUrl ? '#fff' : bg, ...style }}
    >
      {imageUrl ? (
        <img src={imageUrl} alt="" className="h-full w-full object-cover"  referrerPolicy="no-referrer"/>
      ) : (
        <span className="font-mono font-bold text-black" style={{ fontSize: fontSize || Math.round(size * 0.42) }}>
          {initial}
        </span>
      )}
    </span>
  );
}
